import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { getTableColumnStyles, restrictedTableColumns } from "./tableLayout";

const borderColor = "#3498DB";
const styles = StyleSheet.create({
  container: {
    width: "100%",
    borderLeftColor: "#424949",
    borderLeftWidth: 1,
    borderRightColor: "#424949",
    borderRightWidth: 1,
    flexDirection: "row",
    borderBottomColor: "#000000",
    backgroundColor: "#3498DB",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    textAlign: "center",
    color: "white",
    fontFamily: "Helvetica-Bold",
    flexGrow: 1,
    fontSize: 10,
  },
  index: {
    borderRightColor: borderColor,
    borderRightWidth: 1,
    marginTop: 3,
    fontSize: 10,
  },
  fulldate: {
    borderRightColor: borderColor,
    borderRightWidth: 1,
    marginTop: 4,
    fontSize: 10,
  },
  fullname: {
    borderRightColor: borderColor,
    borderRightWidth: 1,
    marginTop: 4,
    fontSize: 10,
  },
  origin: {
    borderRightColor: borderColor,
    borderRightWidth: 1,
    marginTop: 4,
    fontSize: 10,
  },
  destination: {
    borderRightColor: borderColor,
    borderRightWidth: 1,
    marginTop: 4,
    fontSize: 10,
  },
  toll: {
    borderRightColor: borderColor,
    borderRightWidth: 1,
    marginTop: 4,
    fontSize: 9,
  },
  price: {
    borderRightColor: borderColor,
    borderRightWidth: 1,
    marginTop: 4,
    fontSize: 9,
  },
});

const TableHeader = ({ canViewTotal = false }) => {
  const columnStyles = getTableColumnStyles(canViewTotal);

  if (!canViewTotal) {
    return (
      <View style={styles.container}>
        {restrictedTableColumns.map(({ key, label }) => (
          <Text key={key} style={[styles.origin, columnStyles[key]]}>
            {label}
          </Text>
        ))}
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <Text style={[styles.index, columnStyles.index]}>No</Text>
      <Text style={[styles.fullname, columnStyles.fullname]}>NOMBRE</Text>
      <Text style={[styles.fulldate, columnStyles.fulldate]}>FECHA</Text>
      <Text style={[styles.origin, columnStyles.origin]}>ORIGEN</Text>
      <Text style={[styles.destination, columnStyles.destination]}>DESTINO</Text>
      <Text style={[styles.toll, columnStyles.toll]}>PEAJE</Text>
      {canViewTotal && (
        <Text style={[styles.price, columnStyles.price]}>PRECIO</Text>
      )}
    </View>
  );
};

export default TableHeader;
